import { MessagesResult } from 'core/domain/medicationFollowUpMessages'

const initialState: MessagesResult = {
  messageList: [],
  exclusiveStartKey: undefined,
  isCompleted: false,
}

export function createInitialState(): MessagesResult {
  return initialState
}

export const SET_MESSAGES_RESULT = 'messages_result/set' as const
export const CLEAR_MESSAGES_RESULT = 'messages_result/clear' as const

export function setMessagesResult(result: MessagesResult) {
  return {
    type: SET_MESSAGES_RESULT,
    payload: result,
  }
}

export function clearMessagesResult() {
  return {
    type: CLEAR_MESSAGES_RESULT,
  }
}

type SetMessagesResultAction = ReturnType<typeof setMessagesResult>
type ClearMessagesResultAction = ReturnType<typeof clearMessagesResult>
type Action = SetMessagesResultAction | ClearMessagesResultAction

export function reducer(state = createInitialState(), action: Action) {
  switch (action.type) {
    case SET_MESSAGES_RESULT:
      return action.payload
    case CLEAR_MESSAGES_RESULT:
      return initialState
    default:
      return state
  }
}
